import { Optional, SystemSettingsTemplate } from '../../../types/common';
import { SystemData } from '../../../types/systems';

export const systemsSettingsTemplate: SystemSettingsTemplate<SystemData> = {
	sections: {
		'': {
			platform: { type: 'radio-group' },
		},
		Marks: {
			take_off_time: { type: 'slider', max_limit: 60, unit: 'min' },
			time_to_ready_to_fire: { type: 'slider', max_limit: 60, unit: 'min' },
			dismount_time: { type: 'slider', max_limit: 60, unit: 'min' },
			armor: {
				type: 'select',
				data: [
					{ value: 'none', label: 'None' },
					{ value: 'active', label: 'Active' },
					{ value: 'passive', label: 'Passive' },
					{ value: 'reactive', label: 'Reactive' },
				],
			},
			roles: { type: 'multi-checkbox', data: [] },
		},
		Sensors: {
			sensors: {
				type: 'static-table',
				columns: { name: 'Sensor' },
				use_archetypes: false,
				editable: false,
			},
		},
		Emitters: {
			emitters: {
				type: 'static-table',
				columns: { name: 'Emitter' },
				use_archetypes: false,
				editable: false,
			},
		},
		Effectors: {
			effectors: {
				type: 'static-table',
				columns: { name: 'Effector' },
				use_archetypes: false,
				editable: false,
			},
		},
		Dismounts: {
			dismounts: {
				type: 'static-table',
				columns: { name: 'Dismount' },
				use_archetypes: false,
				editable: false,
			},
		},
		Behaviors: {
			blue_subordinate_behavior: { type: 'select' },
			red_subordinate_behavior: { type: 'select' },
			blue_commander_behavior: { type: 'select' },
			red_commander_behavior: { type: 'select' },
		},
		Sensor: {
			side: {
				type: 'select',
				data: [
					{ value: '2', label: 'NONE' },
					{ value: '0', label: 'BLUE' },
					{ value: '1', label: 'RED' },
				],
			},
			cost: 'text',
			symbol: 'symbol-picker',
			name: 'text',
			siso_uid: 'text',
			icon: { type: 'select' },
		},
	},
};

export const defaultSettings: Optional<SystemData, 'id'> = {
	armor: 'none',
	side: 0,
	cost: '0',
	name: 'New system',
	roles: [],
	emitters: [],
	sensors: [],
	effectors: [],
	dismounts: [],
	symbol: '10031000000000000000',
	platform: null,
	id: 0,
	blue_subordinate_behavior: '',
	red_subordinate_behavior: '',
	blue_commander_behavior: '',
	red_commander_behavior: '',
	siso_uid: '0.0.0.0',
	icon: '',
};
